// /src/plugins/shortcuts.ts
import { registerPlugin } from '@capacitor/core';

export type ShortcutPayload = { type: string };

export interface TrauvoShortcutsPlugin {
  addListener(eventName: 'shortcut', cb: (p: ShortcutPayload) => void): Promise<void>;
  getPendingShortcut(): Promise<ShortcutPayload>;
}

export const TrauvoShortcuts = registerPlugin<TrauvoShortcutsPlugin>('TrauvoShortcuts');
